import React from 'react';
import { Spinner, Alert } from '../../../services/notiflix.service';
import AuthService from '../../../services/auth.service';
import { LinkedinSvgIcon } from '../IconProvider';
const LinkedinSignup = () => {
  const linkedInLogin = async () => {
    Spinner.show();
    try {
      let resp = await AuthService.socialSignInRequest('linkedin');
      if (resp.status === 'failure') {
        Spinner.hide();
        Alert.error(resp.message);
        return false;
      }

      Spinner.hide();
      window.location.href = resp?.data;
    } catch (error) {
      Spinner.hide();
      Alert.error(error.message);
    }
  };

  return (
    <button
      onClick={() => linkedInLogin()}
      className="border border-[#F3F3F3] text-[#85919F] bg-white rounded-md flex items-center py-3 px-7"
    >
      <LinkedinSvgIcon /> LinkedIn
    </button>
  );
};

export default LinkedinSignup;
